import React from 'react'
import UserCard from "../Component/UserInfoCard/UserCard"
export default function Location() {
  return (
    <div>
      <UserCard/>
    </div>
  )
}
